export type DefectType = '001' | '002' | '003' | '004' | '005' | '006' | '999'
export type ReturnType = 0 | 1 | 2 | 3
export type ProductType = 0 | 1

/*
0:未処理
100:確認中 
150:発送依頼 
200:検品中 

300:有償修理確認 
400:有償修理対応 
500:無償修理対応
600:完了
700:キャンセル
800:差し戻し
*/
export const RepairStatus = {
  NotProcessed: 0,
  Checking: 100,
  ShippingRequest: 150,
  InspectionInProgress: 200,
  ConfirmationOfChargeableRepair: 300,
  RepairWithCharge: 400,
  FreeRepair: 500,
  Completed: 600,
  Cancel: 700,
  Refund: 800,
} as const
type RepairStatus = typeof RepairStatus[keyof typeof RepairStatus]

// ユーザー側のステータス
export const CustomerRepairStatus = {
  Accepted: 0,
  ShippingRequest: 100,
  Inspection: 150,
  ConfirmationPaidRepair: 200,
  UnderRepair: 300,
  Shipped: 400,
  Refund: 500,
  Cancel: 600,
} as const
type CustomerRepairStatus = typeof RepairStatus[keyof typeof RepairStatus]

export const RepairStatusLabel = {
  NotProcessed: '未処理',
  Checking: '確認中',
  InspectionInProgress: '検品中',
  ConfirmationOfChargeableRepair: '有償修理確認',
  RepairWithCharge: '有償修理対応',
  FreeRepair: '無償修理対応',
  Completed: '完了',
  Cancel: 'キャンセル',
  Refund: '差し戻し',
} as const
type RepairStatusLabel =
  typeof RepairStatusLabel[keyof typeof RepairStatusLabel]

export const RepairStatusInfo: any = {
  [RepairStatus.NotProcessed]: RepairStatusLabel.NotProcessed,
  [RepairStatus.Checking]: RepairStatusLabel.Checking,
  [RepairStatus.InspectionInProgress]: RepairStatusLabel.InspectionInProgress,
  [RepairStatus.ConfirmationOfChargeableRepair]:
    RepairStatusLabel.ConfirmationOfChargeableRepair,
  [RepairStatus.RepairWithCharge]: RepairStatusLabel.RepairWithCharge,
  [RepairStatus.FreeRepair]: RepairStatusLabel.FreeRepair,
  [RepairStatus.Completed]: RepairStatusLabel.Completed,
  [RepairStatus.Cancel]: RepairStatusLabel.Cancel,
  [RepairStatus.Refund]: RepairStatusLabel.Refund,
}

export enum RepairType {
  NO_SERIAL = 0,
  REGISTERED = 1,
}
